const small = "400px"
const medium = "700px"

export default {
  small,
  medium
}
